import React from 'react'
import { Link } from 'react-router-dom'
import { RouteComponentProps } from 'react-router'
import { locationHistory } from 'services/history'
export default class extends React.PureComponent<RouteComponentProps<any> & IPage> {
	itemRender = (route: any, params: any, routes: any, paths: any) => {
		const last = routes.indexOf(route) === routes.length - 1

		return last ? (
			<span>{route.breadcrumbName}</span>
		) : (
			<Link to={'/' + paths.join('/')}>{route.breadcrumbName}</Link>
		)
	}
	render() {
		let { route } = this.props
		let PageComponent: any = route.component
		let { pageOption = {} } = PageComponent
		let { wrapperClassName, disableHeader } = pageOption
		locationHistory.set(this.props.history)
		return <PageComponent {...this.props} />
	}
}



// WEBPACK FOOTER //
// ./src/layouts/components/RouteComponent/index.tsx